<div *ngIf="isLoading" class="nf-overlay">
  <svg class="nf-spinner" viewBox="0 0 50 50">
    <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
    <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
  </svg>
</div>

<form *ngIf="!isLoading" class="pb-4" [formGroup]="customerForm" (ngSubmit)="onSubmit()">


  <div class="form-section">
    <div class="collapsible-section" [class.is-expanded]="primaryInfoExpanded">
      <div class="collapsible-header" role="button" tabindex="0"
        (click)="primaryInfoExpanded = !primaryInfoExpanded"
        (keydown.enter)="primaryInfoExpanded = !primaryInfoExpanded"
        (keydown.space)="$event.preventDefault(); primaryInfoExpanded = !primaryInfoExpanded"
        [attr.aria-expanded]="primaryInfoExpanded">
        <div class="w-full flex items-center justify-between">
          <span class="collapsible-header-title">Primary Information</span>
          <div class="flex items-center gap-2">
            <span *ngIf="mode=='edit' || mode=='view'"
              class="px-3 py-1 text-xs font-semibold mr-2 bg-blue-100 text-blue-700 border border-blue-300 shadow-sm rounded-[0.5rem]">Status:
              {{ getSOStatusLabel(soStatus) }}</span>
            <span class="collapsible-chevron" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="collapsible-content">
        <div class="collapsible-content-inner">
          <div class="flex gap-2 items-start">
            <div class="flex-1">
              <app-dynamic-form [isLoading]="isLoading" [formGroup]="customerForm" [data]="primaryFields || []"
                [gridSize]="5" [viewMode]="viewMode" [fileNamesMap]="formFieldFileNamesMap"
                (fieldChanged)="onChildFieldChanged($event)" (searchQuery)="onPrimaryFormSearchQuery($event)"
                (fileUploadRequested)="onFormFileUpload($event)"
                (fileDownloadRequested)="onFileDownloadRequested($event)">
              </app-dynamic-form>
            </div>

            <div *ngIf="tableData.length != 0" class="w-[12rem]">
              <p-table size="small" [tableStyle]="{ 'border': '1px solid #C9D2DC' }" [value]="tableData">
                <ng-template #header>
                  <tr>
                    <th colspan="2" class="caption">
                      Summary
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-row>
                  <tr class="table-data">
                    <td class="left-data">{{ row.name }}</td>
                    <td class="right-data">₹{{ row.amount | number:'1.0-0' }}</td>
                  </tr>
                </ng-template>
                <ng-template #footer>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-tabs value="2">
    <p-tablist>
      <p-tab *ngFor="let tab of dynamicFormTabs" [value]="tab.id.toString()">
        <p class="font-normal text-sm">{{ tab.title }}</p>
      </p-tab>
      <!-- Related Documents tab — view mode only -->
      <p-tab *ngIf="mode === 'view'" [value]="RELATED_DOCS_TAB_VALUE">
        <p class="font-normal text-sm">Related Documents</p>
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel *ngFor="let tab of dynamicFormTabs" [value]="tab.id.toString()">
        <ng-container>
          <div *ngFor="let subTab of tab.sub_tabs" class="mb-6">
            <ng-container *ngIf="subTab.content.length > 0">
              <h5 *ngIf="subTab.show_heading" class="mb-4 font-semibold">
                {{ subTab.title }}
              </h5>

              <app-dynamic-form *ngIf="subTab.type !== 'table'; else tableNotSupported" [formGroup]="customerForm"
                [viewMode]="viewMode && !subTab.editableInViewMode" [data]="subTab.content"
                [fileNamesMap]="formFieldFileNamesMap" (fieldChanged)="onChildFieldChanged($event)"
                (searchQuery)="onPrimaryFormSearchQuery($event)" (fileUploadRequested)="onFormFileUpload($event)"
                (fileDownloadRequested)="onFileDownloadRequested($event)">
              </app-dynamic-form>

              <ng-template #tableNotSupported>
                <app-item-dynamic-form [formGroup]="customerForm" [tableKey]="subTab.key"
                  [viewMode]="subTab.auditData ? true : viewMode" [tableArray]="getTableFormArray(subTab.key)"
                  [data]="subTab.content" [suggestionsMap]="getSuggestionsMapForTable(subTab.key)"
                  [shouldHideField]="getShouldHideFieldFn(subTab.key)" (searchQuery)="onSearchQuery($event, subTab)"
                  (fieldChanged)="onTableFieldChanged($event, subTab)"
                  (fileUploadRequested)="onTableFileUpload($event, subTab.key)"
                  (fileDownloadRequested)="onFileDownloadRequested($event)" [showBulkActionButtons]="true"
                  [showPagination]="subTab.key === SUB_TAB_KEYS.AUDIT_LOGS"
                  [currentPage]="subTab.key === SUB_TAB_KEYS.AUDIT_LOGS ? auditLogPage : 1"
                  [totalPages]="subTab.key === SUB_TAB_KEYS.AUDIT_LOGS ? auditLogTotalPages : 1"
                  [paginationLoading]="subTab.key === SUB_TAB_KEYS.AUDIT_LOGS && auditLogLoading"
                  (pageChange)="onAuditPageChange($event)" [lineOfBusinessMap]="lineOfBusinessMap">
                </app-item-dynamic-form>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
      </p-tabpanel>

      <!-- Related Documents tab panel — view mode only -->
      <p-tabpanel *ngIf="mode === 'view'" [value]="RELATED_DOCS_TAB_VALUE">
        <lib-related-documents-tab
          [module]="'client-order'"
          [id]="clientSOId"
          emptyMessage="No related documents found for this Sales Order.">
        </lib-related-documents-tab>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <div class="save-container" *ngIf="!viewMode">
    <p-button type="submit" [label]="mode === 'edit' ? 'Update' : 'Save'"
      [disabled]="((approvalStatus === 'approved' || soStatus === 'closed') && mode !== 'duplicate') || isLoading" />
  </div>
  <div class="save-container" *ngIf="(mode === 'view' && clientSOId && soStatus !== 'closed' && soStatus !== 'billed' && !isCancelled)">
    <p-button type="button" label="Close SO" severity="danger" icon="pi pi-lock" (onClick)="closeSO()" [loading]="isLoading"
      pTooltip="Mark SO as Closed" tooltipPosition="top" />
    </div>
</form>